import { createSelector } from 'reselect';

import { createEntityDenormalizer } from '@iconik-io/shared-lib/src/redux/entities/normalizers';

import type { AppState } from '../../../store/types';

const denormalizePlaylist = createEntityDenormalizer('playlists');

const getEntities = (state: AppState) => state.entities;
const getPlaylistId = (_state: AppState, playlistId: string) => playlistId;

export const selectPlaylist = createSelector(
  getEntities,
  getPlaylistId,
  (entities, playlistId) => denormalizePlaylist(entities, playlistId),
);
